import { removeSessionIfTokenHasExpired } from './helpers'
import { SEQUENCE_STEPS as STEPS } from '../utils/constants'

const callResourceAndDispatchActions = (resource: any, options: any) => {
  const { dispatch, types, ...rest } = options
  const keys = Object.keys(types)
  const REQUESTED = keys.find(i => types[i].includes(STEPS[0])) || ''
  const SUCCESSFUL = keys.find(i => types[i].includes(STEPS[1])) || ''
  const FAILED = keys.find(i => types[i].includes(STEPS[2])) || ''
  dispatch({ type: types[REQUESTED] })
  resource({ ...rest })
    .then((data: any) => dispatch({ type: types[SUCCESSFUL], data }))
    .catch((error: any) => {
      removeSessionIfTokenHasExpired(error)
      dispatch({ type: types[FAILED], data: error })
    })
}

export default callResourceAndDispatchActions
